import styled from "styled-components"
import media from "../../theme/breakpoints"

export const NewsletterContainer = styled.div`
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 3px;
  background: ${props => props.theme.colors.secondary};
  max-width: 82rem;
  margin: 10rem auto 3rem;
  text-align: center;
  position: relative;
  padding: 3rem;
  box-sizing: border-box;

  ${media.md`
    margin-top: 6rem;
  `}

  ${media.sm`
    padding: 3rem 2rem;
  `}
`

export const ColoredBar = styled.div`
  background: ${props => props.theme.colors.main};
  width: 100%;
  height: 6px;
  border-radius: 2px 2px 0 0;
  position: absolute;
  top: 0;
  left: 0;
`
